import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Table, Button, Badge, Form, Container } from 'react-bootstrap';
import WhatsAppAPI from '../../api/WhatsAppAPI';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader,
  } from "react-bs-datatable";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ShimmerTable } from "../common/ShimmerTable";
import moment from "moment";

const MyWallet = () => {
  const [wallet, setWallet] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);

  useEffect(() => {
    fetchWallet();
    fetchTransactions();
  }, []);

  const fetchWallet = async () => {
    const res = await WhatsAppAPI.getWalletBalance();
    if(res.success){
      setWallet(res.data);
          setIsSpinner(true);

    }else{
      setWallet([]);
          setIsSpinner(true);

    }
  };

  const fetchTransactions = async () => {
    const res = await WhatsAppAPI.getWalletTransactions();
    if(res.success){
      setTransactions(res.data);
    }else{
      setTransactions([]);
    }
    setIsSpinner(true);
  };

  
  const header = [
    {
      title: "Date",
      prop: "createddate",
      isFilterable: true,
      cell: (row) => (
        <span
          style={{ cursor: "pointer", color: "#007bff" }}
        >
          {row.createddate ? moment(row.createddate).format("D MMMM YYYY, hh : mm A") : "--"}
        </span>
      ),
    },
    {
      title: "Type",
      prop: "type",
      cell: (row) => {
        if (!row.type) {
          return <span className="text-muted">-</span>;
        }
        return (
          <div style={{ maxWidth: "200px" }}>
            <small>
              <span className="fw-semibold">{row.type === 'credit' ? 'Credit' : 'Debit'}</span>
            </small>
          </div>
        );
      
      },
    },
    {
      title: "Amount",
      prop: "amount",
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.amount}
        </span>
      ),
    },
    {
      title: "Reason",
      prop: "reason",
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.reason}
        </span>
      ),
    },
    {
      title: "Balance After",
      prop: "balance_after",
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.balance_after}
        </span>
      ),
    },
    
  ];

  const labels = {
    beforeSelect: " ",
  };

  return (
    <>
   <Container className="mt-5 mb-5">
      {/* Top summary boxes */}
      <Row className="mx-5 mb-4">
        <Col lg={3} md={6} className="mb-3">
          <Card className="p-3 bg-white shadow-sm border-0 rounded-3 text-center">
            <Card.Title className="fw-semibold mb-1">Available Credits</Card.Title>
            <h3 className="fw-bold text-success">{wallet.available_credits || '00'}</h3>
          </Card>
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <Card className="p-3 bg-white shadow-sm border-0 rounded-3 text-center">
            <Card.Title className="fw-semibold mb-1">Total Credited</Card.Title>
            <h3 className="fw-bold text-primary">{wallet.total_credited || '00'}</h3>
          </Card>
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <Card className="p-3 bg-white shadow-sm border-0 rounded-3 text-center">
            <Card.Title className="fw-semibold mb-1">Total Debited</Card.Title>
            <h3 className="fw-bold text-danger">{wallet.total_debited || '00'}</h3>
          </Card>
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <Card className="p-3 bg-white shadow-sm border-0 rounded-3 text-center">
            <Card.Title className="fw-semibold mb-1">Last Credit On</Card.Title>
            <h5 className="fw-bold mt-2">{wallet.last_recharged_on ? moment(wallet.last_recharged_on).format("D MMMM YYYY, hh : mm A") : "--"}</h5>
          </Card>
        </Col>
      </Row>

      {/* Main content: Table and Form side by side */}
      <Row className="mx-5 g-4">
        <Col lg={12} className="mb-3">
          <div className="bg-white shadow-sm border-0 rounded-3 p-4">
            <h5 className="fw-semibold">💳 Wallet Transactions</h5>
            {isSpinner ? (
              <DatatableWrapper
                body={transactions}
                headers={header}
                paginationOptionsProps={{
                  initialState: {
                    rowsPerPage: 10,
                    options: [5, 10, 15, 20],
                  },
                }}
              >
                <Row className="mb-3">
                  <Col lg={4} className="d-flex justify-content-end align-items-end">
                    <Filter className="p-2" />
                  </Col>
                  <Col lg={4} className="d-flex justify-content-start align-items-start">
                    <PaginationOptions labels={labels} />
                  </Col>
                </Row>
                <div className="table-responsive">
                  <Table striped bordered className="related-list-table" responsive="sm">
                    <TableHeader />
                    <TableBody />
                  </Table>
                </div>
                <Pagination />
              </DatatableWrapper>
            ) : (
              <ShimmerTable
                columns={header.length}
                rows={10}
                rowHeight={30}
                rowGap={10}
                columnGap={10}
              />
            )}
          </div>
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  </>

  );
};

export default MyWallet;